'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024$0024anon$00241 from "./java.time.format.-Resolver-Style$$anon$1.js";
import * as $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024$0024anon$00242 from "./java.time.format.-Resolver-Style$$anon$2.js";
import * as $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024$0024anon$00243 from "./java.time.format.-Resolver-Style$$anon$3.js";
var $p;
function $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle() {
  $m_Ljava_time_format_ResolverStyle$();
  return $t_Ljava_time_format_ResolverStyle$__STRICT;
}
export { $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle as $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle };
function $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle() {
  $m_Ljava_time_format_ResolverStyle$();
  return $t_Ljava_time_format_ResolverStyle$__SMART;
}
export { $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle as $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle };
function $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle() {
  $m_Ljava_time_format_ResolverStyle$();
  return $t_Ljava_time_format_ResolverStyle$__LENIENT;
}
export { $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle as $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle };
/** @constructor */
function $c_Ljava_time_format_ResolverStyle$() {
  $n_Ljava_time_format_ResolverStyle$ = this;
  $t_Ljava_time_format_ResolverStyle$__STRICT = new $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024$0024anon$00241.$c_Ljava_time_format_ResolverStyle$$anon$1();
  $t_Ljava_time_format_ResolverStyle$__SMART = new $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024$0024anon$00242.$c_Ljava_time_format_ResolverStyle$$anon$2();
  $t_Ljava_time_format_ResolverStyle$__LENIENT = new $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024$0024anon$00243.$c_Ljava_time_format_ResolverStyle$$anon$3();
  $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle();
  $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle();
  $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle();
}
export { $c_Ljava_time_format_ResolverStyle$ as $c_Ljava_time_format_ResolverStyle$ };
$p = $c_Ljava_time_format_ResolverStyle$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_ResolverStyle$;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle$() {
}
export { $h_Ljava_time_format_ResolverStyle$ as $h_Ljava_time_format_ResolverStyle$ };
$h_Ljava_time_format_ResolverStyle$.prototype = $p;
var $d_Ljava_time_format_ResolverStyle$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_ResolverStyle$, "java.time.format.ResolverStyle$", ({
  ll: 1,
  e: 1,
  aa: 1
}));
export { $d_Ljava_time_format_ResolverStyle$ as $d_Ljava_time_format_ResolverStyle$ };
var $n_Ljava_time_format_ResolverStyle$;
function $m_Ljava_time_format_ResolverStyle$() {
  if ((!$n_Ljava_time_format_ResolverStyle$)) {
    $n_Ljava_time_format_ResolverStyle$ = new $c_Ljava_time_format_ResolverStyle$();
  }
  return $n_Ljava_time_format_ResolverStyle$;
}
export { $m_Ljava_time_format_ResolverStyle$ as $m_Ljava_time_format_ResolverStyle$ };
var $t_Ljava_time_format_ResolverStyle$__STRICT = null;
function $u_Ljava_time_format_ResolverStyle$__STRICT(x) {
  $t_Ljava_time_format_ResolverStyle$__STRICT = x;
}
export { $t_Ljava_time_format_ResolverStyle$__STRICT as $t_Ljava_time_format_ResolverStyle$__STRICT, $u_Ljava_time_format_ResolverStyle$__STRICT as $u_Ljava_time_format_ResolverStyle$__STRICT };
var $t_Ljava_time_format_ResolverStyle$__SMART = null;
function $u_Ljava_time_format_ResolverStyle$__SMART(x) {
  $t_Ljava_time_format_ResolverStyle$__SMART = x;
}
export { $t_Ljava_time_format_ResolverStyle$__SMART as $t_Ljava_time_format_ResolverStyle$__SMART, $u_Ljava_time_format_ResolverStyle$__SMART as $u_Ljava_time_format_ResolverStyle$__SMART };
var $t_Ljava_time_format_ResolverStyle$__LENIENT = null;
function $u_Ljava_time_format_ResolverStyle$__LENIENT(x) {
  $t_Ljava_time_format_ResolverStyle$__LENIENT = x;
}
export { $t_Ljava_time_format_ResolverStyle$__LENIENT as $t_Ljava_time_format_ResolverStyle$__LENIENT, $u_Ljava_time_format_ResolverStyle$__LENIENT as $u_Ljava_time_format_ResolverStyle$__LENIENT };
